function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 10,
  fill: "#CEFBEB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.4571 12.5975C28.1776 12.3175 27.7241 12.3171 27.4446 12.5963L18.854 21.1642L15.7546 17.7979C15.4868 17.5072 15.034 17.4884 14.7428 17.7561C14.4518 18.024 14.4332 18.477 14.701 18.768L18.3053 22.6823C18.4373 22.8258 18.622 22.9091 18.8168 22.9131C18.822 22.9133 18.8271 22.9133 18.8321 22.9133C19.0214 22.9133 19.2035 22.8382 19.3376 22.7045L28.4557 13.6103C28.7359 13.331 28.7364 12.8775 28.4571 12.5975Z",
  fill: "#09BE9E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.2839 18.7839C27.8884 18.7839 27.5678 19.1045 27.5678 19.5C27.5678 23.9488 23.9488 27.5678 19.5 27.5678C15.0515 27.5678 11.4322 23.9488 11.4322 19.5C11.4322 15.0515 15.0515 11.4322 19.5 11.4322C19.8955 11.4322 20.2161 11.1116 20.2161 10.7161C20.2161 10.3206 19.8955 10 19.5 10C14.2616 10 10 14.2616 10 19.5C10 24.7381 14.2616 29 19.5 29C24.7381 29 29 24.7381 29 19.5C29 19.1045 28.6794 18.7839 28.2839 18.7839Z",
  fill: "#09BE9E"
});

var SvgSuccessNotification = function SvgSuccessNotification(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success-notification.cc53166c.svg";
export { ForwardRef as ReactComponent };